<mat-nav-list appAccordion>
    <ng-container *ngFor="let menuitem of menuItems.getMenuitem()">
        <div class="nav-section-label" *ngIf="menuitem.type === 'header'"
             style="padding:16px 16px 4px;font-size:11px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:#9aa3b2;">
            {{ menuitem.name }}
        </div>
        <mat-list-item appAccordionLink routerLinkActive="selected"
                       *ngIf="menuitem.type === 'link' && (!menuitem.adminOnly || (isAdmin$ | async))">
            <a class="menu-item" appAccordionToggle [routerLink]="[ menuitem.state]">
                <mat-icon>{{ menuitem.icon }}</mat-icon>
                <span>{{ menuitem.name }}</span>
            </a>
        </mat-list-item>
    </ng-container>
</mat-nav-list>
